<!-- 
    禅道8372 新增错误页面
 -->
<template>
  <div class="error-content">
      <type1 v-if="type == '1'" />
      <type2 v-else />
  </div>
</template>
<script>
import type1 from "./type1.vue";
import type2 from "./type2.vue";
export default {
  name: "error",
  components: {
      type1,
      type2
  },
  data() {
    return {
        type: "1"
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
        vm.type = vm.$route.query.type
    });
  },
};
</script>